import React, { Component } from "react";
import Layout from "../../Layout/layout";
import "../../styles/alerts/alerts.scss";
import { Helmet } from "react-helmet";
import AlertTable from "./alertTable";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import axios from "axios";
import { downloadCSVFile, apiHost } from "../../api/apiClient";

class Bellnotification extends Component {

  constructor(props) {
    super(props);
    this.state = {
      alertsNotificationList: [],
      notificationTotal: 0,
      pendingNotification: 0,
    };
  }

  componentDidMount() {
    this.getNotification();
  }

  getNotification = async () => {
    try {
      let notification = await axios.get(
        `${apiHost}/api/Notification/LatestNotification`,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({ alertsNotificationList: notification.data })
      console.log(
        "notification ",
        notification.data
      );
      this.notificationPendingAlertCalculation();
      this.props.setLoadingPageAction(false);
    } catch (e) {
      this.props.setLoadingPageAction(false);
      this.props.setErrorMessageAction(`${e}`);
      console.log(`😱 Axios request failed: ${e}`);
    }

  }

  createNotificationList = (data) => {
    let counter = 0;
    let currentList = [...this.state.alertsNotificationList];
    console.log("before Notification currentList", currentList);
    currentList.forEach((item, index) => {
      if (item.id == data.id) {
        currentList[index] = data;
        counter++;
      }
    });
    if (counter == 0) {
      currentList.push(data);
      this.playAudio();
    }

    currentList.sort(function (x, y) {
      var date1 = new Date(x.gPRMC.created);
      var date2 = new Date(y.gPRMC.created);
      return date2 - date1;
    });

    this.setState({
      alertsNotificationList: currentList,
    });
    console.log("After Notification currentList", currentList);
    this.notificationPendingAlertCalculation();
  };

  notificationPendingAlertCalculation = () => {
    let total = 0;
    let pending = 0;
    if (this.state.alertsNotificationList !== "") {
      this.state.alertsNotificationList.forEach((item, index) => {
        total++;

        if (!item.userId) {
          pending++;
        }
      });
    }
    this.setState({
      notificationTotal: total,
      pendingNotification: pending,
    });
  };

  handleAcknowledge = async (id, description) => {
    let url = `${apiHost}/api/Notification/NotificationAcknowledgement`;
    this.props.setLoadingPageAction(true);
    try {
      await axios.post(
        url,
        {
          MessageId: id,
          Acknowledgement: description,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.getNotification();
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  handleDownloadNotification = () => {
    downloadCSVFile(this.state.alertsNotificationList);
  }

  render() {
    return (
      <Layout>
        <Helmet>
          <title>Alert Notification </title>
        </Helmet>
        <div className="contentBody">
          <div className="contentWrapper">
            <div className="alertContent">
              <h2>
                Alert Centre <span>v1.0.4</span>
              </h2>
              {/* <h6> Last refreshed: 19-Feb, 3:23:42 pm </h6> */}


              <AlertTable
                handleAcknowledege={this.handleAcknowledge}
                alertMessage={`${this.state.pendingNotification} of ${this.state.notificationTotal} alerts pending`}
                data={this.state.alertsNotificationList}
                downloadExcel={this.handleDownloadNotification}
              />

            </div>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(Bellnotification);
